/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Document_Title_HelpInputs */



/**
* | output |
* | --- |
* | "Enter the title for your CCSL document" |
*
* @param {Ccsl_Export_Document_Title_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_document_title_help = /** @type {((inputs?: Ccsl_Export_Document_Title_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Document_Title_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Saisissez le titre de votre document CCSL")
	if (locale === "de") return /** @type {LocalizedString} */ ("Geben Sie den Titel für Ihr CCSL-Dokument ein.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci il titolo per il tuo documento CCSL")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Введите название вашего документа CCSL.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Introduzca el título de su documento CCSL")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请输入您的 CCSL 文档标题")
	if (locale === "ja") return /** @type {LocalizedString} */ ("CCSL文書のタイトルを入力してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपने CCSL दस्तावेज़ के लिए शीर्षक दर्ज करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Insira o título do seu documento CCSL.")
	return /** @type {LocalizedString} */ ("Enter the title for your CCSL document")
});